$R.addLang('fr', {
    'clips': 'Emojis',
    'clips-select': 'Sélectionnez un emoji'
});